import Vue from 'vue';
import _ from 'lodash';
import mixin from '../mixin.js';

Vue.component('profile-form', {
    mixins: [mixin],
    inject: ['$validator'],

    props: {
        action: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            default: () => ({})
        }
    },

    created() {
        // A user adatokat betöltjük a formba (Blade-ből jön :data="$user->toJson()")
        if (!_.isEmpty(this.data)) {
            this.form = { ...this.form, ...this.data };
        }
    },

    mounted() {
        console.log('####### mounted: profile-form.vue');
    },

    methods: {

        onBlurPhone() {
            this.$validator.validate('phone0');
        },

        onPhoneValidate(phoneObject) {
            console.log('####### onPhoneValidate(phoneObject) - profile-form.vue', phoneObject);
            this.form.phone0 = phoneObject;
            this.form.phone = phoneObject;
        },

        copytext() {
            this.form.shipping_country  = this.form.billing_country;
            this.form.shipping_name     = this.form.billing_name;
            this.form.shipping_city     = this.form.billing_city;
            this.form.shipping_postcode = this.form.billing_postcode;
            this.form.shipping_address  = this.form.billing_address;
        },

        // Friss captcha tokent kér és megvárja a v-model frissülését
        refreshCaptchaToken() {
            return new Promise((resolve, reject) => {
                this.form.gRecaptchaResponse = null;
                this.$refs.captcha.execute();

                const unwatch = this.$watch('form.gRecaptchaResponse', (val) => {
                    if (val) {
                        unwatch();
                        resolve(val);
                    }
                });

                setTimeout(() => {
                    unwatch();
                    reject(new Error('reCAPTCHA timeout'));
                }, 10000);
            });
        },

        async submit() {
            if (this.processing) return;
            this.processing = true;

            let loader = null;

            try {
                // 1. Validáció
                const result = await this.$validator.validateAll();

                if (!(result && this.form.phone0.valid)) {
                    if (!this.form.phone0.valid && !this.errors.has('phone')) {
                        this.errors.add({
                            field: 'phone',
                            rule: 'required',
                            msg: this.__('__JSON__.Hibás telefonszám')
                        });
                    }

                    this.$notify({
                        type: 'error',
                        title: 'Profil',
                        text: this.__('__JSON__.Egy vagy több megadott adat hibás!'),
                        position: 'left',
                        group: 'appnotif',
                        autohide: false,
                        timeout: 5000,
                    });

                     this.$nextTick(() => {
                        const firstError = document.querySelector('.is-danger:not([style*="display: none"])');
                        if (firstError) {
                            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    });

                    return;
                }

                // 2. Friss captcha token
                await this.refreshCaptchaToken();

                // 3. HTTP küldés
                loader = this.$loading.show();

                const response = await axios.post(this.action, this.form);
                this.onSuccess(response.data);

            } catch (e) {
                if (e.response) {
                    this.onFail(e.response.data.errors || {});
                } else {
                    console.error('submit error:', e);
                    this.$notify({
                        type: 'error',
                        title: 'Profil',
                        text: this.__('__JSON__.Hiba történt a beküldés során!'),
                        position: 'left',
                        group: 'appnotif',
                        autohide: false,
                        timeout: 5000,
                    });
                }
            } finally {
                this.processing = false;
                if (loader) loader.hide();
                if (this.$refs.captcha) this.$refs.captcha.execute();
            }
        },

        onSuccess(data) {
            console.log('onSuccess()', data);

            if (data.redirect) {
                window.location.replace(data.redirect);
                return;
            }

            if (data.error) {
                this.error = data.error;
                this.$notify({
                    type: 'error',
                    group: 'appnotif',
                    title: 'Profil mentése',
                    text: 'A mentés nem sikerült!'
                });
            } else if (data.success) {
                this.success = data.success;
                this.$notify({
                    type: 'success',
                    group: 'appnotif',
                    title: 'Profil mentése',
                    text: 'A mentés sikerült!'
                });
            }
        },

        onFail(errors) {
            console.warn('onFail()', errors);
            this.$notify({
                type: 'error',
                group: 'appnotif',
                title: 'Profil mentése',
                text: 'Hiba az adatok mentése közben!'
            });

            const bag = this.$validator.errors;
            Object.keys(errors).forEach(key => {
                const splitted = key.split('.', 2);
                if (splitted.length > 1) {
                    bag.add(splitted[0] + '_' + splitted[1], errors[key][0]);
                } else {
                    bag.add({ field: key, msg: errors[key][0] });
                }
            });
        }
    },

    data() {
        return {
            processing: false,
            success: '',
            error: '',
            form: {
                csrf: '',
                gRecaptchaResponse: null,
                name: '',
                first_name: '',
                last_name: '',
                email: '',
                phone_country_code: '36',
                phone_area_code: '',
                phone: '',
                phone0: '',
                billing_country: '1',
                billing_name: '',
                billing_city: '',
                billing_postcode: '',
                billing_address: '',
                tax_number: '',
                eu_tax_number: '',
                shipping_country: '1',
                shipping_name: '',
                shipping_city: '',
                shipping_postcode: '',
                shipping_address: '',
                is_newsletter: 0,
                is_terms: 0,
                is_privacy: 0,
                newsletter: 0,
                user_type: 'm',
            }
        };
    }
});
